import ApiService from "./ApiService";

const ROOT_URL = "/services/onboarding/api/processvariable/private";

const ProcessVariableApi = new ApiService(ROOT_URL, "", {
  setProcessVariables: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/setprocessvariables", data, onSuccess, onError);
  },
  getActualProcessVariables: function(ctx, codes, processId, onSuccess, onError) {
    this.apiGET(ctx, "/getactualprocessvariablesbycode?codes=" + codes + "&processId=" + processId, onSuccess, onError);
  }
});

export default ProcessVariableApi;



// WEBPACK FOOTER //
// ./src/service/ProcessVariableService.js